module.exports = __webpack_public_path__ + "img/user.48d9257c.png";